import { CampaignTypes } from 'src/shared/enums/consumables.enum';
import { config } from 'config/config';
import getConfig from 'next/config';
const { DEFAULT_LANGUAGE } = getConfig().publicRuntimeConfig;
const { BLACK_FRIDAY, BLACK_FRIDAY_AI } = CampaignTypes;

const setPrefixImage = (prefix: string): string => {
  return prefix?.toUpperCase()?.replace('-', '_');
}

const prefixImage = setPrefixImage(DEFAULT_LANGUAGE); 

const blackFridayItem = {
  id: BLACK_FRIDAY,
    label: 'black_friday',
    images: {
      coupon: {
        mobile: `${config.APP.MEDIA_CON}Discovery_Coupon_Black_Friday_2023_Mobile_v1.png`,
        desktop: `${config.APP.MEDIA_CON}Discovery_Coupon_Black_Friday_2023_Desktop_v1.png`,
        mobileSelected: `${config.APP.MEDIA_CON}Discovery_Coupon_Black_Friday_2023_Mobile_Focus_v1.png`,
        desktopSelected: `${config.APP.MEDIA_CON}Discovery_Coupon_Black_Friday_2023_Desktop_Focus_v1.png`,
      },
      banner: {
        home: {
          mobile: `${config.APP.MEDIA_CON}Discovery_Banner_MyCoupons_Black_Friday_2023_Mobile.png`,
          desktop: `${config.APP.MEDIA_CON}${prefixImage}_Discovery_Banner_Home_Black_Friday_2023_Desktop.png`,
        },
        myCoupons: {
          mobile: `${config.APP.MEDIA_CON}Discovery_Banner_MyCoupons_Black_Friday_2023_Mobile.png`,
          desktop: `${config.APP.MEDIA_CON}Discovery_Banner_MyCoupons_Black_Friday_2023_Desktop.png`,
        },
      },
    },

    styles: {
      coupon: {
        title: '#FCE4A2',
        pointsInfo: 'white',
        extraPoints: 'white',
        description: 'white'
      },
      banner: {
        home: {
          title: '#414141',
          clock: '#414141',
          date: '#8A8A8A',
          background: `linear-gradient(to top, rgba(245,230,189,1) 0%, rgba(255,255,255,1) 100%)`,
        },

        myCoupons: {
          title: '#FCE4A2',
          clock: 'white',
          date: 'white',
          background: `linear-gradient(to top, rgba(245,230,189,1) 0%, rgba(255,255,255,1) 100%)`,
          btnPrimaryColor: 'btn-primary--light'
        },
      }
    },

    literals: {
      coupon: {
        title: 'consumable.coupon.title.discovery.campaign-black-friday',
      },
    },
}

export const DiscoveryCampaignsConfig = {
  [BLACK_FRIDAY]: blackFridayItem,
  [BLACK_FRIDAY_AI]: blackFridayItem
};